/**
 * Enhance pagination links to use htmx for AJAX loading
 * Converts regular pagination links to use REST endpoint with hx-get
 * This file was AI generated using Kimi K2.5
 */
(function () {
  'use strict'

  function enhancePagination() {
    const paginationNavs = document.querySelectorAll('.pagination .nav-links')

    paginationNavs.forEach(nav => {
      const resultsContainer = nav.closest('#listing-results') || nav.previousElementSibling

      if (!resultsContainer) return

      let postType = resultsContainer.dataset.postType

      if (postType === 'search') return

      const links = nav.querySelectorAll('a.page-numbers, a.prev.page-numbers, a.next.page-numbers')

      links.forEach(link => {
        if (link.dataset.htmxEnhanced) return

        const href = link.getAttribute('href')
        if (!href || href === '#') return

        const url = new URL(href, window.location.origin)
        const params = new URLSearchParams(url.search)

        let restUrl

        const paged = params.get('paged') || params.get('page') || '1'
        restUrl = `${window.location.origin}/wp-json/htmx/v1/listing/${postType}?paged=${paged}`

        params.forEach((value, key) => {
          if (key !== 'paged') {
            restUrl += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`
          }
        })

        const targetId = resultsContainer.id || 'listing-results'

        // Add htmx attributes
        link.setAttribute('hx-get', restUrl)
        link.setAttribute('hx-target', `#${targetId}`)
        link.setAttribute('hx-swap', 'outerHTML')
        link.setAttribute('hx-push-url', 'true')

        link.dataset.htmxEnhanced = 'true'
      })
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhancePagination)
  } else {
    enhancePagination()
  }

  document.body.addEventListener('htmx:load', function () {
    enhancePagination()
  })

  document.body.addEventListener('htmx:afterSwap', function (evt) {
    const target = evt.detail.target

    if (target.querySelector('.pagination') || document.querySelector('.pagination')) {
      setTimeout(enhancePagination, 0)
    }
  })
})()